import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { JoveButton, JoveTextFieldControlled } from '@jove-frontend/mui';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import { apiJoveResetPassword } from 'libs/uikit/src/api/combineApi';
import { REQUEST_SUCCESS_CODE } from 'libs/uikit/src/constants';
import { useFormContext } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ResetPasswordForm = function ResetPasswordForm(props) {
  var onResetPassword = props.onResetPassword,
      onBackToLogin = props.onBackToLogin;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useState = useState(false),
      submitting = _useState[0],
      setSubmitting = _useState[1];

  var _useState2 = useState(false),
      passwordVisible = _useState2[0],
      setPasswordVisible = _useState2[1];

  var _useState3 = useState(false),
      confirmPasswordVisible = _useState3[0],
      setConfirmPasswordVisible = _useState3[1];

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      getValues = _useFormContext.getValues,
      handleSubmit = _useFormContext.handleSubmit;

  var email = getValues('email');
  /**
   * request
   */

  var requestResetPassword = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getValues, email, token, password, params, _yield$apiJoveResetPa, _yield$apiJoveResetPa2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getValues = getValues(), email = _getValues.email, token = _getValues.token, password = _getValues.password;
              params = {
                email: email,
                reset_token: token,
                password: password
              };
              setSubmitting(true);
              _context.next = 5;
              return apiJoveResetPassword(params);

            case 5:
              _yield$apiJoveResetPa = _context.sent;
              _yield$apiJoveResetPa2 = _slicedToArray(_yield$apiJoveResetPa, 1);
              res = _yield$apiJoveResetPa2[0];
              setSubmitting(false);

              if ((res === null || res === void 0 ? void 0 : res.code) === REQUEST_SUCCESS_CODE) {
                toast === null || toast === void 0 ? void 0 : toast.success($t('text:login.password_reset_success'));
                onResetPassword === null || onResetPassword === void 0 ? void 0 : onResetPassword();
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestResetPassword() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var continueAction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              handleSubmit(requestResetPassword)();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function continueAction() {
      return _ref2.apply(this, arguments);
    };
  }();

  var backToLoginAction = function backToLoginAction() {
    onBackToLogin === null || onBackToLogin === void 0 ? void 0 : onBackToLogin();
  };

  var togglePasswordVisibilityAction = function togglePasswordVisibilityAction() {
    setPasswordVisible(function (visible) {
      return !visible;
    });
  };

  var toggleConfirmPasswordVisibilityAction = function toggleConfirmPasswordVisibilityAction() {
    setConfirmPasswordVisible(function (visible) {
      return !visible;
    });
  };

  var validateConfirmPassword = function validateConfirmPassword(value) {
    return value === getValues('password') ? true : $t('text:login.passwords_not_match');
  };

  var passwordEndAdornment = /*#__PURE__*/_jsx(InputAdornment, {
    position: "end",
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "small",
      edge: "end",
      "aria-label": "toggle password visibility",
      onClick: togglePasswordVisibilityAction,
      children: passwordVisible ? /*#__PURE__*/_jsx(VisibilityOff, {
        fontSize: "small"
      }) : /*#__PURE__*/_jsx(Visibility, {
        fontSize: "small"
      })
    })
  });

  var confirmPasswordEndAdornment = /*#__PURE__*/_jsx(InputAdornment, {
    position: "end",
    children: /*#__PURE__*/_jsx(IconButton, {
      size: "small",
      edge: "end",
      "aria-label": "toggle confirm password visibility",
      onClick: toggleConfirmPasswordVisibilityAction,
      children: confirmPasswordVisible ? /*#__PURE__*/_jsx(VisibilityOff, {
        fontSize: "small"
      }) : /*#__PURE__*/_jsx(Visibility, {
        fontSize: "small"
      })
    })
  });

  return /*#__PURE__*/_jsxs(Box, {
    component: "form",
    noValidate: true,
    autoComplete: "on",
    className: "flex w-full flex-col space-y-6",
    children: [/*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-2",
      children: /*#__PURE__*/_jsx(Typography, {
        component: "h1",
        className: "text-3xl font-black text-[#202020] md:text-4xl",
        children: $t('text:login.reset_your_password')
      })
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "email",
      control: control,
      disabled: true,
      autoComplete: "email",
      label: $t('text:login.email_label'),
      placeholder: $t('text:login.email_placeholder')
    }), /*#__PURE__*/_jsx(Typography, {
      className: "rounded-xl bg-gray-50 px-4 py-3 text-sm leading-6 text-gray-600",
      children: $t('text:login.resetting_hint', {
        email: email
      })
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "password",
      control: control,
      rules: {
        required: $t('text:login.enter_new_password')
      },
      autoFocus: true,
      autoComplete: "new-password",
      type: passwordVisible ? 'text' : 'password',
      label: $t('text:login.new_password_label'),
      placeholder: $t('text:login.new_password_placeholder'),
      endAdornment: passwordEndAdornment
    }), /*#__PURE__*/_jsx(JoveTextFieldControlled, {
      name: "confirmPassword",
      control: control,
      rules: {
        required: $t('text:login.confirm_new_password'),
        validate: validateConfirmPassword
      },
      autoComplete: "new-password",
      type: confirmPasswordVisible ? 'text' : 'password',
      label: $t('text:login.confirm_password_label'),
      placeholder: $t('text:login.confirm_password_placeholder'),
      endAdornment: confirmPasswordEndAdornment
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col items-center space-y-6",
      children: /*#__PURE__*/_jsx(JoveButton, {
        variant: "contained",
        color: "primary",
        size: "large",
        loading: submitting,
        className: "w-full",
        onClick: continueAction,
        children: $t('text:login.reset_password')
      })
    })]
  });
};

export default ResetPasswordForm;